import React, { useState, useEffect } from "react";
import { Table, Input, Form, Typography } from "antd";
import moment from "moment";
import "./calender.css";
import { useDispatch } from "react-redux";
import { updateAttendance } from "../../../actions/AttendenceAction";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  form,
  ...restProps
}) => {
  const handleChange = (e) => {
    if (dataIndex === "f_exitTime") {
      const newExit = e.target.value;

      // --- compute new overtime ---
      let fOverDecimal = 0;
      if (newExit && newExit !== "--") {
        let fExit = newExit;
        
        const curDate = moment(record.attendanceDate);
        const specialStart = "2026-02-19";
        const specialEnd = "2026-03-20";
        const isSpecial = curDate.isBetween(specialStart, specialEnd, 'day', '[]');

        if (isSpecial) {
           const otStart = moment("15:30:00", "HH:mm:ss");
           const otLimit = moment("17:35:00", "HH:mm:ss");
           const fExitCap = moment("17:35:00", "HH:mm:ss");
           
           if (moment(fExit, "HH:mm:ss").isAfter(fExitCap)) {
             fExit = "17:35:00";
           }

           const finalExit = moment(fExit, "HH:mm:ss");
           
           if (finalExit.isAfter(otStart)) {
             const effectiveExit = finalExit.isBefore(otLimit) ? finalExit : otLimit;
             fOverDecimal = moment.duration(effectiveExit.diff(otStart)).asHours();
           }
        } else {
          // Regular logic
          // Adjust Final Exit (max 19:00)
          if (moment(fExit, "HH:mm:ss").isAfter(moment("19:00:00", "HH:mm:ss"))) {
            fExit = "19:00:00";
          }

          const scheduledExit = moment("17:00:00", "HH:mm:ss");
          const finalExit = moment(fExit, "HH:mm:ss");
          if (finalExit.isAfter(scheduledExit)) {
            const diffHours = moment
              .duration(finalExit.diff(scheduledExit))
              .asHours();
            fOverDecimal = Math.min(diffHours, 2);
          }
        }
      }

      const fOverTimeStr = hoursToTime(fOverDecimal);

      // update both f_exitTime & f_overTime in form
      form.setFieldsValue({
        f_exitTime: newExit,
        f_overTime: fOverTimeStr,
      });
    }
  };

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[{ required: false, message: `Please Input ${title}!` }]}
        >
          <Input onChange={handleChange} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

// Helper: convert decimal hours → HH:mm
const hoursToTime = (decimalHours) => {
  if (!decimalHours || decimalHours <= 0) return "00:00";
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

// Helper: convert "HH:mm" string → decimal hours
const timeToDecimal = (timeStr) => {
  if (!timeStr || timeStr === "--") return 0;
  const [h, m] = timeStr.split(":").map(Number);
  return h + m / 60;
};

const AttendanceTimeCard = ({ data }) => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const dispatch = useDispatch();
  console.log(dataSource)

  const attendanceData =
    (data && data.attendance && data.attendance.data) || [];
  const attendanceMap = {};
  attendanceData.forEach((item) => {
    attendanceMap[item.attendanceDate] = { ...item, id: item.id };
  });

  const firstRecord = attendanceData[0] || null;
  const year = firstRecord
    ? moment(firstRecord.attendanceDate).year()
    : moment().year();
  const month = firstRecord
    ? moment(firstRecord.attendanceDate).month()
    : moment().month();
  const daysInMonth = moment().year(year).month(month).daysInMonth();

  useEffect(() => {
    const fullMonthData = [];

    for (let day = 1; day <= daysInMonth; day++) {
      const date = moment([year, month, day]);
      const formattedDate = date.format("YYYY-MM-DD");
      const isFriday = date.format("dddd") === "Friday";
      const isFestivalHoliday = formattedDate === "2026-03-19" || (formattedDate >= "2026-03-21" && formattedDate <= "2026-03-26");

      if (isFestivalHoliday) {
        fullMonthData.push({
          key: formattedDate,
          attendanceDate: formattedDate,
          entryTime: "--",
          exitTime: "--",
          f_exitTime: "--",
          shift: "Eid Vacation",
          isLate: "--",
          lateTime: "--",
          overTime: "--",
          f_overTime: "00:00",
          note: "",
        });
      } else if (isFriday) {
        fullMonthData.push({
          key: formattedDate,
          attendanceDate: formattedDate,
          entryTime: "--",
          exitTime: "--",
          f_exitTime: "--",
          shift: "WEEKEND",
          isLate: "--",
          lateTime: "--",
          overTime: "--",
          f_overTime: "00:00",
          note: "",
        });
      } else if (attendanceMap[formattedDate]) {
        const a = attendanceMap[formattedDate];

        // Exit & Overtime from BioTime
        const bioExit = a.exitTime || "--";

        // Adjust Final Exit (max 19:00)
        let fExit = a.f_exitTime || bioExit;
        if (
          fExit &&
          fExit !== "--" &&
          moment(fExit, "HH:mm:ss").isAfter(moment("19:00:00", "HH:mm:ss"))
        ) {
          fExit = "19:00:00";
        }

        // f_overTime calculation
        let fOverDecimal = 0;
        if (fExit && fExit !== "--") {
          const curDate = moment(formattedDate);
          const specialStart = "2026-02-19";
          const specialEnd = "2026-03-20";
          const isSpecial = curDate.isBetween(specialStart, specialEnd, 'day', '[]');

          if (isSpecial) {
            const otStart = moment("15:30:00", "HH:mm:ss");
            const otLimit = moment("17:35:00", "HH:mm:ss");
            const fExitCap = moment("17:35:00", "HH:mm:ss");
            
            if (moment(fExit, "HH:mm:ss").isAfter(fExitCap)) {
              fExit = "17:35:00";
            }

            const finalExit = moment(fExit, "HH:mm:ss");
            
            if (finalExit.isAfter(otStart)) {
              const effectiveExit = finalExit.isBefore(otLimit) ? finalExit : otLimit;
              fOverDecimal = moment.duration(effectiveExit.diff(otStart)).asHours();
            }
          } else {
            const scheduledExit = moment("17:00:00", "HH:mm:ss");
            const finalExit = moment(fExit, "HH:mm:ss");
            if (finalExit.isAfter(scheduledExit)) {
              const diffHours = moment
                .duration(finalExit.diff(scheduledExit))
                .asHours();
              fOverDecimal = Math.min(diffHours, 2);
            }
          }
        }

        const fOverTimeStr = hoursToTime(fOverDecimal);

        fullMonthData.push({
          key: formattedDate,
          id: a.id,
          attendanceDate: a.attendanceDate,
          entryTime: a.entryTime || "--",
          exitTime: bioExit,
          f_exitTime: fExit,
          shift: a.shift || "--",
          isLate: a.isLate ? "Yes" : "No",
          lateTime: a.lateTime || 0,
          overTime: a.overTime || 0,
          f_overTime: fOverTimeStr,
          note: a.note || "",
        });
      } else {
        fullMonthData.push({
          key: formattedDate,
          attendanceDate: formattedDate,
          entryTime: "--",
          exitTime: "--",
          f_exitTime: "--",
          shift: "--",
          isLate: "--",
          lateTime: "--",
          overTime: "--",
          f_overTime: "00:00",
          note: "",
        });
      }
    }

    setDataSource(fullMonthData);
  }, [data]);

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const cancel = () => setEditingKey("");

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        const updatedItem = { ...item, ...row };

        // Convert HH:mm → decimal before API
        const fOverDecimal = timeToDecimal(updatedItem.f_overTime);

        newData.splice(index, 1, {
          ...updatedItem,
          f_overTime: hoursToTime(fOverDecimal),
        });

        setDataSource(newData);
        setEditingKey("");

        if (item.id) {
          await dispatch(
            updateAttendance(item.id, {
              f_exitTime: updatedItem.f_exitTime,
              entryTime: updatedItem.entryTime,
              f_overTime: fOverDecimal,
              note: updatedItem.note,
            })
          );
        }
      }
    } catch (err) {
      console.log("Validation Failed:", err);
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "attendanceDate",
      render: (t) => new Date(t).toLocaleDateString("en-GB"),
    },
    { title: "Entry Time", dataIndex: "entryTime", editable: true },
    { title: "Final ExitTime", dataIndex: "f_exitTime", editable: true },
    {
      title: "Shift",
      dataIndex: "shift",
      render: (t) => (t ? t.toUpperCase() : ""),
    },
    { title: "Final Overtime", dataIndex: "f_overTime", editable: true },
    { title: "Note", dataIndex: "note", editable: true },
    {
      title: "Action",
      dataIndex: "operation",
      className: "no-print",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{ marginRight: 8 }}
            >
              Save
            </Typography.Link>
            <Typography.Link onClick={cancel}>Cancel</Typography.Link>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          >
            Edit
          </Typography.Link>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) =>
    col.editable
      ? {
          ...col,
          onCell: (record) => ({
            record,
            inputType: "text",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
            form,
          }),
        }
      : col
  );

  return (
    <div className="attendance-table">
      <h3>Monthly Attendance List</h3>
      <Form form={form} component={false}>
        <Table
          components={{
            body: { cell: (props) => <EditableCell {...props} form={form} /> },
          }}
          bordered
          dataSource={dataSource}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={false}
          summary={() => {
            // compute total overtime minutes
            let totalMinutes = 0;
            dataSource.forEach((row) => {
              totalMinutes += timeToDecimal(row.f_overTime) * 60;
            });

            const totalHours = Math.floor(totalMinutes / 60);
            const totalMins = totalMinutes % 60;

            // Rounded hours (if >=30 mins, round up)
            const roundedHours = totalMins >= 30 ? totalHours + 1 : totalHours;

            // HH:mm format (non-rounded, exact sum)
            const totalHHMM = `${String(totalHours).padStart(2, "0")}:${String(
              totalMins
            ).padStart(2, "0")}`;

            // Decimal hours
            const totalDecimal = (totalMinutes / 60).toFixed(2);
            console.log(totalDecimal);

            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={4} align="right">
                    <strong>Total Final Overtime (HH:mm):</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <strong>{totalHHMM}</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} />
                </Table.Summary.Row>

                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={4} align="right">
                    <strong>Total Final Overtime (Rounded Hours):</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <strong>{roundedHours}</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} />
                </Table.Summary.Row>

                {/* <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={4} align="right">
                    <strong>Total Final Overtime (Decimal Hours):</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <strong>{totalDecimal}</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} />
                </Table.Summary.Row> */}
              </>
            );
          }}
        />
      </Form>
    </div>
  );
};

export default AttendanceTimeCard;
